<template>
  <auth-layout title="Use Case" stepNo="1">
    <div class="text-darkBlue">
      <div class="text-center w-full md:w-3/5 mx-auto mt-4">
        <h1 class="text-lg md:text-3xl font-bold">
          What would you like to sign up as?
        </h1>
      </div>
      <div class="w-full md:w-3/5 mx-auto mt-4 font-semibold px-3">
        <div :class="{ selected: useCase == '3PL' }" class="single-option shadow" @click="selectUseCase('3PL')">
          <div class="single-option__inner">
            <div class="single-option__">
              <p>3rd Party Logistics</p>
            </div>
            <div class="single-option__select-circle">
              <div class="single-option__select-circle__inner"></div>
            </div>
          </div>
        </div>
        <div :class="{ selected: useCase == 'ondemand' }" class="single-option shadow"
          @click="selectUseCase('ondemand')">
          <div class="single-option__inner">
            <div class="single-option__">
              <p>On-Demand Customer</p>
            </div>
            <div class="single-option__select-circle">
              <div class="single-option__select-circle__inner"></div>
            </div>
          </div>
        </div>
        <div :class="{ selected: useCase == 'mac' }" class="single-option shadow" @click="selectUseCase('mac')">
          <div class="single-option__inner">
            <div class="single-option__">
              <p>Merchant Aggregator Customer</p>
            </div>
            <div class="single-option__select-circle">
              <div class="single-option__select-circle__inner"></div>
            </div>
          </div>
        </div>
        <div :class="{ selected: useCase == 'ecm' }" class="single-option shadow" @click="selectUseCase('ecm')">
          <div class="single-option__inner">
            <div class="single-option__">
              <p>Ecommerce Merchant</p>
            </div>
            <div class="single-option__select-circle">
              <div class="single-option__select-circle__inner"></div>
            </div>
          </div>
        </div>
        <div :class="{ selected: useCase == 'enc' }" class="single-option shadow" @click="selectUseCase('enc')">
          <div class="single-option__inner">
            <div class="single-option__">
              <p>Enterprise Customer</p>
            </div>
            <div class="single-option__select-circle">
              <div class="single-option__select-circle__inner"></div>
            </div>
          </div>
        </div>
        <div class="my-8">
          <base-button text="Next" width="w-full" p="py-3" :loading="savingUserUseCase" @click="saveUseCase" />
        </div>
      </div>
    </div>

    <template v-slot:text>
      <div class="text-white">
        <h1 class="text-3xl font-bold">
          Use Case
        </h1>
      </div>
    </template>
  </auth-layout>
</template>

<script>
import AuthLayout from "../../Auth/Authlayout/OnDemand";

export default {
  components: {
    AuthLayout,
  },
  data() {
    return {
      useCase: "3PL",
      loading: false,
      savingUserUseCase: false,
    };
  },
  methods: {
    selectUseCase(useCase) {
      this.useCase = useCase;
    },
    async saveUseCase() {
      if (this.useCase != "3PL" && this.useCase != "ondemand") {
        this.generateToast(
          "You can currently only register as a 3rd party logistics partner!",
          "error"
        );
      } else {
        this.savingUserUseCase = true;
        let request = {
          onboardingType: this.useCase,
        };
        let userId = localStorage.getItem("userId");
        // let quantumUserId = localStorage.getItem("quantumUserId");
        request.userId = userId;

        try {
          let response = await this.$_saveUserUseCase(request);
          console.log(response)
          this.handleSuccessfulResponse();
        } catch (error) {
          this.savingUserUseCase = false;
          this.handleError(error);
          console.log(error);
        }
      }
    },
    handleSuccessfulResponse() {
      this.savingUserUseCase = false;
      if (this.useCase == "3PL") {
        this.$router.push("/onboarding/account-type");
      } else {
        this.$router.push("/onboarding/account-owner");
      }
    },
  },
};
</script>

<style scoped>
.single-option {
  width: 100%;
  height: 4.5rem;
  border-radius: 5px;
  margin: 0.75rem 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: transform ease 0.5s;
}

.single-option:hover {
  transform: scale(1.015);
}

.single-option.selected {
  background: #fbc210;
}

.single-option__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;
  padding: 0 0.5rem;
  width: 100%;
  height: 70%;
  border-radius: 5px;
}

/* .single-option.selected .single-option__inner {
} */

.single-option__select-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 0.5px solid #eff2f7;
}

.single-option__select-circle__inner {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #eff2f7;
}

@media screen and (max-width: 768px) {
  .single-option {
    width: 100%;
    height: 4rem;
  }

  .use-case-form__header-text {
    font-size: 1.5rem;
  }
}
</style>
